import styled from 'styled-components'
import Flex from '../../Layout/Flex/Flex'
import { FontStyle } from '../../Core/Typography/Font/Font.styles'
import { FormFooterProps } from './types'
import { TFunctionResultChildren } from 'src/components/Core/Typography/Font/types'
export const FormStyle = styled('form')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const FormHeader = styled('header')<TFunctionResultChildren>`
  color: ${props => props.theme.colors.main.dark};
`

export const FormTitle = styled(FontStyle).attrs({
  as: 'h3',
  tag: 'h3',
  isMiller: true,
})<TFunctionResultChildren>`
  margin-bottom: 16px;
`

export const FormDescription = styled(FontStyle)<TFunctionResultChildren>`
import { TFunctionResult } from 'src/components/Core/Typography/Font/types'

  margin-bottom: 16px;
`

export const FormFooter = styled(Flex).attrs({
  as: 'footer',
})<FormFooterProps>`
  width: 100%;
  margin-top: 16px;
  padding-top: ${props => (props?.insideModal ? '16px' : '8px')};
  margin-bottom: ${props => (props?.insideModal ? '-8px' : '40px')};
  border-top: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  justify-content: ${props =>
    props?.noOfButtons === 2 ? 'space-between' : 'flex-end'};
`

export const FormFooterActionsLeft = styled('div')``

export const FormFooterActionsRight = styled('div')`
  button:nth-child(2) {
    margin-left: 16px;
  }
`

export const ActionIconWrapper = styled('div')`
  cursor: pointer;
`

export const UnderLineText = styled('span')`
  text-decoration: underline;
`
